import { InjectionToken } from '@angular/core';
import type { ThemePalette } from '../core/common';

/**
 * Default `mat-slide-toggle` options that can be overridden.
 */
export interface MatSlideToggleDefaultOptions {
  /** Whether toggle action triggers value changes in slide toggle. */
  disableToggleValue?: boolean;

  /** Default color for slide toggles. */
  color?: ThemePalette;
}

/**
 * Injection token to be used to override the default options for `mat-slide-toggle`
 */
export const MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS = new InjectionToken<MatSlideToggleDefaultOptions>(
  'mat-slide-toggle-default-options',
  {
    providedIn: 'root',
    factory: () => ({ disableToggleValue: false }),
  },
);
